import React from "react";
import { useTranslation } from "react-i18next";

import { InterviewService } from "../../../services/InterviewService";
import { showWarning } from "../../../services/ModalService";

export default function ExcludeInterview({ interviewId }) {
  let { t } = useTranslation();
  function deleteDraftedInterview() {
    showWarning(
      t(
        "You are about to delete this interview. Are you sure you want to proceed with it?"
      ),
      () => {
        InterviewService.deleteDraftedInterview(interviewId).then((data) => {
          if (!data?.error) {
            refreshInterviewList();
            window.close();
          }
        });
      }
    );
  }
  function refreshInterviewList() {
    if (window.opener)
      window.opener.postMessage("INTERVIEWLISTREFRESH", window.location.origin);
  }
  return (
    <button
      className="dropdown-item"
      type="button"
      onClick={() => {
        deleteDraftedInterview();
      }}
    >
      {t("Delete Interview")}
    </button>
  );
}
